import { jsx as _jsx } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import UITag from 'UIComponents/tag/UITag';
import AdCampaignsCell from '../components/goals-table/cells/ad-campaigns/AdCampaignsCell';
import ProgressCell from '../components/goals-table/cells/goal-progress/GoalProgressCell';
import DurationCell from '../components/goals-table/cells/GoalDurationCell';
import GoalNameCell from '../components/goals-table/cells/GoalNameCell';
import { COLUMN_NAME, GOAL_STATUS_TO_UI_TAG_COLOR } from '../constants/goals';
import { TdNoBorder } from '../utils/styles';
export const GOALS_TABLE_COLUMN_CONFIG = {
  [COLUMN_NAME.AD_CAMPAIGNS]: {
    sortable: false,
    columnName: COLUMN_NAME.AD_CAMPAIGNS,
    HeaderContentComponent: () => /*#__PURE__*/_jsx(FormattedMessage, {
      message: "goals-reporting-lib.table.headers.adCampaigns"
    }),
    CellComponent: ({
      row
    }) => {
      return /*#__PURE__*/_jsx(TdNoBorder, {
        children: /*#__PURE__*/_jsx(AdCampaignsCell, {
          goalTarget: row
        })
      });
    }
  },
  [COLUMN_NAME.DURATION]: {
    sortable: false,
    columnName: COLUMN_NAME.DURATION,
    HeaderContentComponent: () => /*#__PURE__*/_jsx(FormattedMessage, {
      message: "goals-reporting-lib.table.headers.duration"
    }),
    CellComponent: ({
      row
    }) => {
      return /*#__PURE__*/_jsx(TdNoBorder, {
        children: /*#__PURE__*/_jsx(DurationCell, {
          goalTarget: row
        })
      });
    }
  },
  [COLUMN_NAME.GOAL_NAME]: {
    property: 'hs_goal_name',
    sortable: true,
    columnName: COLUMN_NAME.GOAL_NAME,
    HeaderContentComponent: () => /*#__PURE__*/_jsx(FormattedMessage, {
      message: "goals-reporting-lib.table.headers.goalName"
    }),
    CellComponent: ({
      row
    }) => {
      return /*#__PURE__*/_jsx(GoalNameCell, {
        row: row
      });
    }
  },
  [COLUMN_NAME.PROGRESS]: {
    property: 'hs_kpi_progress_percent',
    sortable: true,
    columnName: COLUMN_NAME.PROGRESS,
    HeaderContentComponent: () => /*#__PURE__*/_jsx(FormattedMessage, {
      message: "goals-reporting-lib.table.headers.progress"
    }),
    CellComponent: ({
      row
    }) => {
      return /*#__PURE__*/_jsx(TdNoBorder, {
        children: /*#__PURE__*/_jsx(ProgressCell, {
          goalTarget: row
        })
      });
    }
  },
  [COLUMN_NAME.STATUS]: {
    sortable: false,
    columnName: COLUMN_NAME.STATUS,
    HeaderContentComponent: () => /*#__PURE__*/_jsx(FormattedMessage, {
      message: "goals-reporting-lib.table.headers.status"
    }),
    CellComponent: ({
      row
    }) => {
      const {
        status
      } = row;
      return /*#__PURE__*/_jsx(TdNoBorder, {
        children: /*#__PURE__*/_jsx(UITag, {
          inline: true,
          use: GOAL_STATUS_TO_UI_TAG_COLOR[status],
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            "data-test-id": "goal-status-text",
            message: `goals-reporting-lib.table.status.${status}`
          })
        })
      });
    }
  }
};